import { TweenMax } from "gsap";

/**
 * Mathematical utility functions.
 */
class VisualUtil
{


    /**
     * Tween the color tint of an object. The color value is multiplied per pixel of the texture.
     * @param obj
     * @param endColor
     * @param time
     */
    static tintTween(obj, endColor, time)
    {
        if (obj.tintTween)
        {
            TweenMax.killTweensOf(obj.tintTween);
        }

        obj.tintTween =
        {
            r: ((obj.tint & 0xff0000) >> 16),
            g: ((obj.tint & 0x00ff00) >> 8),
            b: (obj.tint & 0x0000ff)
        };

        let finalColor =
            {
                r: (endColor & 0xff0000 >> 16),
                g: (endColor & 0x00ff00 >> 8),
                b: (endColor & 0x0000ff)
            };

        TweenMax.to(obj.tintTween, time, {r:finalColor.r, g:finalColor.g, b:finalColor.b,
            onUpdate:VisualUtil.setTint, onUpdateParams:[obj], onUpdateScope:VisualUtil,
            onComplete:VisualUtil.endTintTween, onCompleteParams:[obj], onCompleteScope:VisualUtil});
    }

    static blackeningTween(obj, endColor, time)
    {
        if (obj.tintTween)
        {
            TweenMax.killTweensOf(obj.tintTween);
        }

        obj.tintTween =
        {
            r: ((obj.tint & 0xff0000) >> 16),
            g: ((obj.tint & 0x00ff00) >> 8),
            b: (obj.tint & 0x0000ff)
        };

        let previousColor = obj.tintTween

        let finalColor =
            {
                r: (endColor & 0xff0000 >> 16),
                g: (endColor & 0x00ff00 >> 8),
                b: (endColor & 0x0000ff)
            };

        return TweenMax.to(obj.tintTween, time, {r:finalColor.r, g:finalColor.g, b:finalColor.b,
            onUpdate:VisualUtil.setTint, onUpdateParams:[obj], onUpdateScope:VisualUtil});
    }

    /**
     * @private
     * @param obj
     */
    static setTint (obj)
    {
        let c = obj.tintTween;
        obj.tint = (c.r << 16) | (c.g << 8) | c.b;
    }


    /**
     * @private
     * @param obj
     */
    static endTintTween (obj)
    {
        delete obj.tintTween;
    }


}

export default VisualUtil